/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestPasswordResetResponse
 */
export interface RequestPasswordResetResponse {
    /**
     * 
     * @type {string}
     * @memberof RequestPasswordResetResponse
     */
    passwordResetRequestId: string;
}

/**
 * Check if a given object implements the RequestPasswordResetResponse interface.
 */
export function instanceOfRequestPasswordResetResponse(value: object): value is RequestPasswordResetResponse {
    if (!('passwordResetRequestId' in value) || value['passwordResetRequestId'] === undefined) return false;
    return true;
}

export function RequestPasswordResetResponseFromJSON(json: any): RequestPasswordResetResponse {
    return RequestPasswordResetResponseFromJSONTyped(json, false);
}

export function RequestPasswordResetResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestPasswordResetResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'passwordResetRequestId': json['passwordResetRequestId'],
    };
}

export function RequestPasswordResetResponseToJSON(json: any): RequestPasswordResetResponse {
    return RequestPasswordResetResponseToJSONTyped(json, false);
}

export function RequestPasswordResetResponseToJSONTyped(value?: RequestPasswordResetResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'passwordResetRequestId': value['passwordResetRequestId'],
    };
}

